import api from "../api";
import { Property, PropertyListItem } from "./propertyModel";

export const getProperties = async (customerId: number): Promise<PropertyListItem[]> => {
  return (await api.get<PropertyListItem[]>(`/customers/${customerId}/properties`)).data
}

export const getDeletedProperties = async (): Promise<PropertyListItem[]> => {
  return (await api.get<PropertyListItem[]>(`/properties/deleted`)).data
}

export const getProperty = async (customerId: number, propertyId: number): Promise<Property> => {
  return (await api.get<Property>(`/customers/${customerId}/properties/${propertyId}`)).data
}

export const saveProperty = async ({customerId, property}: {customerId: number, property: Property}): Promise<Property> => {
  return (await api.post<Property>(`/customers/${customerId}/properties`, property)).data
}

export const deleteProperty = async ({customerId, propertyId}:{customerId: number, propertyId: number}): Promise<void> => {
  return (await api.delete(`/customers/${customerId}/properties/${propertyId}`))
}

export const getDeletedProperty = async (propertyId: number): Promise<Property> => {
  return (await api.get<Property>(`/deleted/${propertyId}/property`)).data
}

export const restoreProperty = async (propertyId: number): Promise<void> => {
  return (await api.post(`/properties/restore/${propertyId}`))
}
